// const API_URL = "http://localhost:1300/api/v1";
const API_URL = "https://balosh.herokuapp.com/api/v1";

export default API_URL;
